import styled from 'styled-components'
import { INTER } from '@styles/fonts'

import bankTopUpIcon from '@assets/icons/TransactionDetailBankTopUp.svg'
import cryptoIcon from '@assets/icons/TransactionDetailCrypto.svg'
import bankIcon from '@assets/icons/TransactionDetailBank.svg'
import transferIcon from '@assets/icons/TransactionDetailTransfer.svg'
import arrowUpIcon from '@assets/icons/TransactionDetailArrowUp.svg'
import arrowDownIcon from '@assets/icons/TransactionDetailArrowDown.svg'
import paymentLinkIcon from '@assets/icons/TransactionPaymentLink.svg'

// Icon components
export const BankTopUp = styled.img.attrs({
    src: bankTopUpIcon
})``

export const Crypto = styled.img.attrs({
    src: cryptoIcon
})``

export const Bank = styled.img.attrs({
    src: bankIcon
})``

export const Transfer = styled.img.attrs({
    src: transferIcon,
    width: 24,
    height: 24
})``

export const ArrowUp = styled.img.attrs({
    src: arrowUpIcon
})``

export const ArrowDown = styled.img.attrs({
    src: arrowDownIcon
})``

export const PaymentLink = styled.img.attrs({
    src: paymentLinkIcon
})``

// Container and text components
export const TagContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid #fff;
    border-radius: 24px;
    padding: 8px 14px;
    background-color: rgba(1, 1, 1, 0.4);
`

export const TagText = styled.span`
    font-family: ${INTER.regular};
    font-size: 12px;
    color: white;
`
